import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {i18n} from '../../../translate/i18n'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'

// type MonthItemsResponseType = {
//   month: string
//   total: number
// }

const DashboardContent: FC = () => {
  const [loading] = useState(false)

  // const initializeDashboard = async (startDate: string, finalDate: string) => {
  //   try {
  //     setLoading(true)

  //     const [categoryRes, productsRes, monthRes, allMonthRes] = await Promise.all([
  //       GET(`/dashboard/seller-category?startDate=${startDate}&finalDate=${finalDate}`),
  //       GET(`/dashboard/seller-products?startDate=${startDate}&finalDate=${finalDate}`),
  //       GET(`/dashboard/seller-month?startDate=${startDate}&finalDate=${finalDate}`),
  //       GET(`/dashboard/seller-all-month?startDate=${startDate}&finalDate=${finalDate}`),
  //     ])

  //     setLoading(false)
  //     setCategory(categoryRes.data)
  //     setProducts(productsRes.data)
  //     setSellersByMonth(monthRes.data.sellers)
  //     setTotalValuesByMonth(
  //       allMonthRes.data.map((monthItem: MonthItemsResponseType) => ({
  //         month: monthItem.month,
  //         total: monthItem.total.toFixed(2),
  //       }))
  //     )
  //   } catch (e) {
  //     setLoading(false)
  //     console.log(e)
  //   }
  // }

  // function init() {
  //   try {
  //     const finalDate = new Date().toISOString().split('T')[0]
  //     const startDate = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]

  //     setStartDate(startDate)
  //     setFinalDate(finalDate)

  //     initializeDashboard(startDate, finalDate)
  //   } catch (error) {}
  // }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`dashboard.welcome`)}
                </span>

                <BreadCrumbs />

                {/* <span className='fw-normal bg-primary rounded fs-6 text-white py-1 px-2 my-2 fw-bold'>
                  {`Total de pedidos de ${getCurrentMonth()}: ${sellersByMonth}`}
                </span> */}
              </h3>
            </div>
            <div className='card-body'>
              <span className='fw-normal text-muted fs-6 ext-white py-1 my-2 fw-bold'>
                {i18n.t(`dashboard.describe_dashboard`)}
              </span>
            </div>
            {/* <div className='card-body'>
              <div className='d-flex justify-content-between mb-10'>
                <div className='d-flex gap-4'>
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    placeholder='Data Inicial'
                    label={'Data Inicial'}
                    value={startDate}
                    change={(value: string) => {
                      setStartDate(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    placeholder='Data Final'
                    label={'Data Final'}
                    value={finalDate}
                    change={(value: string) => {
                      setFinalDate(value)
                    }}
                  />
                </div>
                <div className='flex-grow-1 mb-2 d-flex justify-content-end align-items-end'>
                  <Button
                    text='Filtrar'
                    color='primary'
                    size='small'
                    icon='fas fa-filter'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      initializeDashboard(startDate,finalDate)
                    }}
                    btnClass='fw-bolder '
                  />
                </div>
              </div>
              <div className='d-flex flex-row justify-content-between flex-wrap gap-5'>
                <div style={{ flex: 1 }}>
                  <DashboardTable
                    data={products}
                    headers={[
                      { key: i18n.t(`dashboard.products`), value: 'name', type: 'default' },
                      { key: i18n.t(`dashboard.quantity`), value: 'sellers', type: 'default' },
                      { key: i18n.t(`dashboard.total`), value: 'total', type: 'money' },
                    ]}
                    title={i18n.t(`dashboard.totals_by_products`)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <DashboardTable
                    data={category}
                    headers={[
                      { key: i18n.t(`dashboard.category`), value: 'name', type: 'default' },
                      { key: i18n.t(`dashboard.quantity`), value: 'sellers', type: 'default' },
                      { key: i18n.t(`dashboard.total`), value: 'total', type: 'money' },
                    ]}
                    title={i18n.t(`dashboard.totals_by_category`)}
                  />
                </div>
              </div>

              <div className='card w-100 border p-10 mt-10'>
                <div className='d-flex justify-content-between'>
                  <h3 className='card-title fw-bold fs-2 mb-1 text-gray-800'>{i18n.t(`dashboard.last_orders`)}</h3>
                  <Button
                    text={i18n.t(`buttons.overview`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate('/chartorders')}
                  />
                </div>
                {totalValuesByMonth.length > 0 && (
                  <LineChart
                    isMoney
                    nameValue='Total'
                    data={totalValuesByMonth.map((monthItem) => monthItem.total)}
                    options={totalValuesByMonth.map((monthItem) => monthItem.month)}
                  />
                )}
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  )
}

const Dashboard: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[{title: 'Dashboard', path: 'dashboard', isActive: true}]}>
        {intl.formatMessage({id: 'MENU.DASHBOARD'})}
      </PageTitle>
      <DashboardContent />
    </>
  )
}

export {Dashboard}
